var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPrevious = function SvgIcPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 12",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.22 6.72A.75.75 0 0 1 0 6.19v-.38a.77.77 0 0 1 .22-.53L5.36.15a.5.5 0 0 1 .71 0l.71.71a.49.49 0 0 1 0 .7L2.33 6l4.45 4.44a.5.5 0 0 1 0 .71l-.71.7a.5.5 0 0 1-.71 0L.22 6.72Z"
  })));
};
export default SvgIcPrevious;